/*
 * Copyright (c) 2018. Viscomp LLC. All rights are reserved!
 */

let getPageUrl = function () {
  const page = window.location.hash.substr(1);
  if (page !== void 0 && page !== "") {
    return parseInt(page.substring(5), 10);
  } else {
    return 1;
  }
};
let setPageUrl = function (selectedPage) {
  const pageLink = "#page-" + selectedPage;
  if (history.pushState) {
    history.pushState(null, null, pageLink);
  } else {
    location.hash = pageLink;
  }
};
export { getPageUrl, setPageUrl };